import { render, staticRenderFns } from "./webMenuConfig.vue?vue&type=template&id=542daa96&scoped=true&"
import script from "./webMenuConfig.vue?vue&type=script&lang=js&"
export * from "./webMenuConfig.vue?vue&type=script&lang=js&"
import style0 from "./webMenuConfig.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./webMenuConfig.vue?vue&type=style&index=1&id=542daa96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542daa96",
  null
  
)

export default component.exports